module.exports = __webpack_public_path__ + "static/media/ranger.c7fadeec.svg";